module.exports = __webpack_public_path__ + "img/age-confirm-bg.f46de8df.png";